<p-confirmDialog />
<div class="layout-wrapper" (click)="onLayoutClick()" [ngClass]="{'layout-horizontal': app.horizontalMenu,
                'layout-wrapper-static': staticMenuActive,
                'layout-rightpanel-active': rightPanelActive,
                'layout-topbar-mobile-active': topbarMobileMenuActive,
                'layout-megamenu-mobile-active': megaMenuMobileActive,
                'layout-sidebar-mobile-active': menuMobileActive,
                'p-input-filled': app.inputStyle === 'filled',
                'p-ripple-disabled': !app.ripple}" [class]="app.menuColor">

    <app-menu></app-menu>

    <app-topbar></app-topbar>

    <div class="layout-main">

        <div class="layout-content" id="layout-content">
            <p-toast></p-toast>
            <router-outlet></router-outlet>
        </div>
    </div>

    <div class="layout-main-mask"></div>

</div>
<custom-loading-panel></custom-loading-panel>
<custom-alert/>




